import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as DeploymentActions from './../deployments/store/deployment.actions';
import * as AppActions from './app.actions';

@Injectable()
export class AppEffects {
  /**
   * Pushes a new error message
   */
  pushErrorMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        DeploymentActions.RetrievingUsersFromSelectedOfficeFailure
      ),
      mergeMap((input) => {
        return of(AppActions.ChangePushStatus({
          message: input.errorMessage,
          code: 'danger',
        }));
      })
    )
  );

  constructor(
    private readonly actions$: Actions
    ) {
  }
}
